export default {
  name: 'PersData',
  data() {
    return {
      persText: '',
      loading: false,
      error: '',
    };
  },
  mounted() {
    this.loadPolicy();
  },
  methods: {
    async loadPolicy() {
      this.loading = true;
      this.error = '';

      this.$store.getters.axl.post('profiles/api/register/page', { page: 'pers' })
        .then(async (response) => {
          this.persText = response.data.page;
          this.loading = false;
        })
        .catch(async (error) => {
          console.error('Ошибка загрузки:', error);
          this.error = 'Не удалось загрузить документ';
          this.persText = this.getFallbackText();
          this.loading = false;
        });
    },

    getFallbackText() {
      return `
        <p>Не удалось загрузить документ.</p>
        <p>Пожалуйста, ознакомьтесь с документом по
          <a href="https://wheel.promo-online.pro/pers" target="_blank">ссылке</a>
        </p>
      `;
    },
  },
};
